// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e216174d","389":"895f5bc3","455":"4044d65e","857":"f8384c1d","977":"e31f6b95"}[chunkId] + ".chunk.js";
};